export const subcategoriaProyectosData = [
  { "id": 1, "nombre": "COC", "subCategoria": "Restaurant" },
  { "id": 2, "nombre": "Beer Joint", "subCategoria": "Restaurant" },
  { "id": 3, "nombre": "Cien Fuegos", "subCategoria": "Restaurant" },
  { "id": 4, "nombre": "Homa Smokehouse", "subCategoria": "Restaurant" },
  { "id": 5, "nombre": "Timbao", "subCategoria": "Restaurant" },
  { "id": 6, "nombre": "Aton Beer", "subCategoria": "Restaurant" },
  { "id": 7, "nombre": "Hoppiness", "subCategoria": "Restaurant" },
  { "id": 8, "nombre": "Huelga", "subCategoria": "Restaurant" },
  { "id": 9, "nombre": "Toma Mate", "subCategoria": "Restaurant" },
  { "id": 10, "nombre": "Edward", "subCategoria": "Restaurant" },
  { "id": 11, "nombre": "Capo", "subCategoria": "Restaurant" },
  { "id": 12, "nombre": "Mila", "subCategoria": "Restaurant" },
  { "id": 13, "nombre": "Tokin", "subCategoria": "Restaurant" },
  { "id": 14, "nombre": "Inmigrantes", "subCategoria": "Restaurant" },
  { "id": 15, "nombre": "Socios", "subCategoria": "Restaurant" },
  { "id": 16, "nombre": "Convento", "subCategoria": "Mixed Use" },
  { "id": 17, "nombre": "Manjatu", "subCategoria": "Restaurant" },
  { "id": 18, "nombre": "Algo Grosso", "subCategoria": "Retail" },
  { "id": 19, "nombre": "Gremio Gallery", "subCategoria": "Mixed Use" },
  { "id": 20, "nombre": "Soberana", "subCategoria": "Restaurant" },
  { "id": 21, "nombre": "Felicity Pop Up", "subCategoria": "Retail" },
  { "id": 22, "nombre": "Felicity Shopping", "subCategoria": "Retail" },
  { "id": 23, "nombre": "Felicity 1", "subCategoria": "Retail" },
  { "id": 24, "nombre": "Felicity Gremio", "subCategoria": "Retail" },
  { "id": 25, "nombre": "Barilatte Urca", "subCategoria": "Retail" },
  { "id": 26, "nombre": "Barilatte Dino", "subCategoria": "Retail" },
  { "id": 27, "nombre": "Unito", "subCategoria": "Restaurant" },
  { "id": 28, "nombre": "Suite House Carilo", "subCategoria": "Hotel" },
  { "id": 29, "nombre": "Merce", "subCategoria": "Restaurant" },
  { "id": 30, "nombre": "Che Mono", "subCategoria": "Restaurant" },
  { "id": 31, "nombre": "Tokin Villa Allende", "subCategoria": "Restaurant" },
  { "id": 32, "nombre": "Hotel Azur Lobby", "subCategoria": "Hotel" },
  { "id": 33, "nombre": "Blend Offices", "subCategoria": "Office" },
  { "id": 34, "nombre": "Innovation Lab", "subCategoria": "Office" },
  { "id": 35, "nombre": "Vidal Offices", "subCategoria": "Office" },
  { "id": 36, "nombre": "Nu Posta Urbana", "subCategoria": "Restaurant" },
  { "id": 37, "nombre": "El Mercadillo 1", "subCategoria": "Retail" },
  { "id": 38, "nombre": "Utuco", "subCategoria": "Restaurant" },
  { "id": 39, "nombre": "LaMaquinita Co Quilmes", "subCategoria": "Office" },
  { "id": 40, "nombre": "Creativity Group Offices", "subCategoria": "Office" },
  { "id": 41, "nombre": "Brevet CC", "subCategoria": "Restaurant" },
  { "id": 42, "nombre": "Panino", "subCategoria": "Restaurant" },
  { "id": 43, "nombre": "Cordiez Mixo", "subCategoria": "Mall" },
  { "id": 44, "nombre": "Central Club", "subCategoria": "Mixed Use" },
  { "id": 45, "nombre": "Hers Spa", "subCategoria": "Retail" },
  { "id": 46, "nombre": "Anik", "subCategoria": "Restaurant" },
  { "id": 47, "nombre": "Galo", "subCategoria": "Restaurant" },
  { "id": 48, "nombre": "MTVD Cafe", "subCategoria": "Office" },
  { "id": 49, "nombre": "Noxion Cordoba", "subCategoria": "Retail" },
  { "id": 50, "nombre": "La Maquinita Co Godoy Cruz", "subCategoria": "Office" },
  { "id": 51, "nombre": "De Pastura", "subCategoria": "Retail" },
  { "id": 52, "nombre": "Felicity Showroom", "subCategoria": "Retail" },
  { "id": 53, "nombre": "El Mercadillo Obispo Oro", "subCategoria": "Retail" },
  { "id": 54, "nombre": "Barilatte Chacabuco", "subCategoria": "Retail" },
  { "id": 55, "nombre": "Barilatte OHiggins", "subCategoria": "Retail" },
  { "id": 56, "nombre": "Barilatte Alta Cordoba", "subCategoria": "Retail" },
  { "id": 5001, "nombre": "Valpo 1", "subCategoria": "Residential" },
  { "id": 5002, "nombre": "Valpo 2", "subCategoria": "Residential" },
  { "id": 5003, "nombre": "Caserio", "subCategoria": "Residential" },
  { "id": 5004, "nombre": "Casa el Bosque", "subCategoria": "Residential" },
  { "id": 5005, "nombre": "Canuelas Village", "subCategoria": "Residential" },
  { "id": 5006, "nombre": "Comuna 14", "subCategoria": "Residential" },
  { "id": 5007, "nombre": "La Luisita", "subCategoria": "Residential" },
  { "id": 5008, "nombre": "Casa Molvento", "subCategoria": "Residential" },
  { "id": 5009, "nombre": "Casa La Serena", "subCategoria": "Residential" },
  { "id": 5010, "nombre": "Homes Co", "subCategoria": "Residential" },
  { "id": 5011, "nombre": "Barrio Calandria II", "subCategoria": "Planning" },
  { "id": 5012, "nombre": "Puerto Nautico", "subCategoria": "Planning" },
  { "id": 5013, "nombre": "Club Nautico", "subCategoria": "Planning" },
  { "id": 5014, "nombre": "Casa Cañuelas chico", "subCategoria": "Residential" },
  { "id": 5015, "nombre": "Housing Plena", "subCategoria": "Residential" },
  { "id": 5016, "nombre": "Parque Industrial Entrance", "subCategoria": "Planning" },
  { "id": 5017, "nombre": "Ruka", "subCategoria": "Residential" },
  { "id": 5018, "nombre": "Housing Bali", "subCategoria": "Residential" },
  { "id": 5019, "nombre": "Viavara", "subCategoria": "Planning" },
  { "id": 5020, "nombre": "Casas Campo Chico", "subCategoria": "Residential" },
  { "id": 5021, "nombre": "Fusina", "subCategoria": "Commercial" },
  { "id": 5022, "nombre": "Duplex Brisas", "subCategoria": "Residential" },
  { "id": 5023, "nombre": "Housing Serra", "subCategoria": "Residential" },
  { "id": 5024, "nombre": "Puerto 53", "subCategoria": "Commercial" },
  { "id": 5025, "nombre": "Casa Rustica", "subCategoria": "Residential" },
  { "id": 5026, "nombre": "Casa Alta", "subCategoria": "Residential" },
  { "id": 5027, "nombre": "Casa Campestre", "subCategoria": "Residential" },
  { "id": 5028, "nombre": "Casa Concreto", "subCategoria": "Residential" },
  { "id": 5029, "nombre": "Casa Entre Muros", "subCategoria": "Residential" },
  { "id": 5030, "nombre": "Casa Escalonada", "subCategoria": "Residential" },
  { "id": 5031, "nombre": "Casa Galería", "subCategoria": "Residential" },
  { "id": 5032, "nombre": "Casa Gavion", "subCategoria": "Residential" },
  { "id": 5033, "nombre": "Casa Gris", "subCategoria": "Residential" },
  { "id": 5034, "nombre": "Casa Ladrillo", "subCategoria": "Residential" },
  { "id": 5035, "nombre": "Casa Mirador", "subCategoria": "Residential" },
  { "id": 5036, "nombre": "Casa Negra", "subCategoria": "Residential" },
  { "id": 5037, "nombre": "Casa Ocre", "subCategoria": "Residential" },
  { "id": 5038, "nombre": "Casa Pétrea", "subCategoria": "Residential" },
  { "id": 5039, "nombre": "Casa Techos", "subCategoria": "Residential" },
  { "id": 5040, "nombre": "Casa Ventana", "subCategoria": "Residential" },
  { "id": 5041, "nombre": "Casa San Miguel", "subCategoria": "Residential" },
  { "id": 5042, "nombre": "Club House", "subCategoria": "Residential" },
  { "id": 5043, "nombre": "Cabanas Tierra Alta", "subCategoria": "Residential" },
  { "id": 5044, "nombre": "Casa Hotel Nomada", "subCategoria": "Residential" },
  { "id": 5045, "nombre": "Hotel casa blanca", "subCategoria": "Residential" },
  { "id": 5046, "nombre": "Casa Firenze", "subCategoria": "Residential" },
  { "id": 5047, "nombre": "Barrio Trina", "subCategoria": "Planning" },
  { "id": 5048, "nombre": "Barrio Calandria Norte", "subCategoria": "Planning" },
  { "id": 5049, "nombre": "COTA45", "subCategoria": "Commercial" },
  { "id": 5050, "nombre": "Centro Comercial Pilar", "subCategoria": "Commercial" },
  { "id": 5051, "nombre": "Centro Comercial Pila", "subCategoria": "Commercial" },
  { "id": 8001, "nombre": "Coc", "subCategoria": "Design" },
  { "id": 8002, "nombre": "Brevet", "subCategoria": "Design" },
  { "id": 8003, "nombre": "Central Club", "subCategoria": "Design" },
  { "id": 8004, "nombre": "Unito", "subCategoria": "Design" },
  { "id": 8005, "nombre": "Che Mono", "subCategoria": "Design" },
  { "id": 8006, "nombre": "Barilatte", "subCategoria": "Design" },
  { "id": 8007, "nombre": "P53", "subCategoria": "Architecture" },
  { "id": 8008, "nombre": "Mercadillo", "subCategoria": "Design" },
  { "id": 8009, "nombre": "La Celeste", "subCategoria": "Design" },
  { "id": 8010, "nombre": "Homa", "subCategoria": "Design" },
  { "id": 8011, "nombre": "SUSS", "subCategoria": "Design" },
  { "id": 8012, "nombre": "Valpo", "subCategoria": "Architecture" },
  { "id": 8013, "nombre": "Barrio Calandria 2", "subCategoria": "Architecture" },
  { "id": 8014, "nombre": "Comuna 14", "subCategoria": "Architecture" },
  { "id": 8015, "nombre": "Hosuing Plena", "subCategoria": "Architecture" },
  { "id": 8016, "nombre": "Barrio Calandria Norte", "subCategoria": "Architecture" },
  { "id": 8017, "nombre": "Cota 45", "subCategoria": "Architecture" },
  { "id": 8018, "nombre": "HAYDEE", "subCategoria": "Design" },
  { "id": 8019, "nombre": "Distrito F", "subCategoria": "Design" },
  { "id": 8020, "nombre": "1111", "subCategoria": "Architecture" },
  { "id": 8021, "nombre": "Once Once", "subCategoria": "Architecture" }

];
export const  subcategoriaProyectosDataES = [
  { "id": 1,   "nombre": "COC",                         "subCategoria": "Restaurante" },
  { "id": 2,   "nombre": "Beer Joint",                  "subCategoria": "Restaurante" },
  { "id": 3,   "nombre": "Cien Fuegos",                 "subCategoria": "Restaurante" },
  { "id": 4,   "nombre": "Homa Smokehouse",             "subCategoria": "Restaurante" },
  { "id": 5,   "nombre": "Timbao",                      "subCategoria": "Restaurante" },
  { "id": 6,   "nombre": "Aton Beer",                   "subCategoria": "Restaurante" },
  { "id": 7,   "nombre": "Hoppiness",                   "subCategoria": "Restaurante" },
  { "id": 8,   "nombre": "Huelga",                      "subCategoria": "Restaurante" },
  { "id": 9,   "nombre": "Toma Mate",                   "subCategoria": "Restaurante" },
  { "id": 10,  "nombre": "Edward",                      "subCategoria": "Restaurante" },
  { "id": 11,  "nombre": "Capo",                        "subCategoria": "Restaurante" },
  { "id": 12,  "nombre": "Mila",                        "subCategoria": "Restaurante" },
  { "id": 13,  "nombre": "Tokin",                       "subCategoria": "Restaurante" },
  { "id": 14,  "nombre": "Inmigrantes",                 "subCategoria": "Restaurante" },
  { "id": 15,  "nombre": "Socios",                      "subCategoria": "Restaurante" },
  { "id": 16,  "nombre": "Convento",                    "subCategoria": "Uso mixto" },
  { "id": 17,  "nombre": "Manjatu",                     "subCategoria": "Restaurante" },
  { "id": 18,  "nombre": "Algo Grosso",                 "subCategoria": "Retail" },
  { "id": 19,  "nombre": "Gremio Gallery",              "subCategoria": "Uso mixto" },
  { "id": 20,  "nombre": "Soberana",                    "subCategoria": "Restaurante" },
  { "id": 21,  "nombre": "Felicity Pop Up",             "subCategoria": "Retail" },
  { "id": 22,  "nombre": "Felicity Shopping",           "subCategoria": "Retail" },
  { "id": 23,  "nombre": "Felicity 1",                  "subCategoria": "Retail" },
  { "id": 24,  "nombre": "Felicity Gremio",             "subCategoria": "Retail" },
  { "id": 25,  "nombre": "Barilatte Urca",              "subCategoria": "Retail" },
  { "id": 26,  "nombre": "Barilatte Dino",              "subCategoria": "Retail" },
  { "id": 27,  "nombre": "Unito",                       "subCategoria": "Restaurante" },
  { "id": 28,  "nombre": "Suite House Carilo",          "subCategoria": "Hotel" },
  { "id": 29,  "nombre": "Merce",                       "subCategoria": "Restaurante" },
  { "id": 30,  "nombre": "Che Mono",                    "subCategoria": "Restaurante" },
  { "id": 31,  "nombre": "Tokin Villa Allende",         "subCategoria": "Restaurante" },
  { "id": 32,  "nombre": "Hotel Azur Lobby",            "subCategoria": "Hotel" },
  { "id": 33,  "nombre": "Blend Offices",               "subCategoria": "Oficina" },
  { "id": 34,  "nombre": "Innovation Lab",              "subCategoria": "Oficina" },
  { "id": 35,  "nombre": "Vidal Offices",               "subCategoria": "Oficina" },
  { "id": 36,  "nombre": "Nu Posta Urbana",             "subCategoria": "Restaurante" },
  { "id": 37,  "nombre": "El Mercadillo 1",             "subCategoria": "Retail" },
  { "id": 38,  "nombre": "Utuco",                       "subCategoria": "Restaurante" },
  { "id": 39,  "nombre": "LaMaquinita Co Quilmes",      "subCategoria": "Oficina" },
  { "id": 40,  "nombre": "Creativity Group Offices",    "subCategoria": "Oficina" },
  { "id": 41,  "nombre": "Brevet CC",                   "subCategoria": "Restaurante" },
  { "id": 42,  "nombre": "Panino",                      "subCategoria": "Restaurante" },
  { "id": 43,  "nombre": "Cordiez Mixo",                "subCategoria": "Shopping" },
  { "id": 44,  "nombre": "Central Club",                "subCategoria": "Uso mixto" },
  { "id": 45,  "nombre": "Hers Spa",                    "subCategoria": "Retail" },
  { "id": 46,  "nombre": "Anik",                        "subCategoria": "Restaurante" },
  { "id": 47,  "nombre": "Galo",                        "subCategoria": "Restaurante" },
  { "id": 48,  "nombre": "MTVD Cafe",                   "subCategoria": "Oficina" },
  { "id": 49,  "nombre": "Noxion Cordoba",              "subCategoria": "Retail" },
  { "id": 50,  "nombre": "La Maquinita Co Godoy Cruz",  "subCategoria": "Oficina" },
  { "id": 51,  "nombre": "De Pastura",                  "subCategoria": "Retail" },
  { "id": 52,  "nombre": "Felicity Showroom",           "subCategoria": "Retail" },
  { "id": 53,  "nombre": "El Mercadillo Obispo Oro",    "subCategoria": "Retail" },
  { "id": 54,  "nombre": "Barilatte Chacabuco",         "subCategoria": "Retail" },
  { "id": 55,  "nombre": "Barilatte OHiggins",          "subCategoria": "Retail" },
  { "id": 56,  "nombre": "Barilatte Alta Cordoba",      "subCategoria": "Retail" },
  { "id": 5001,"nombre": "Valpo 1",                     "subCategoria": "Residencial" },
  { "id": 5002,"nombre": "Valpo 2",                     "subCategoria": "Residencial" },
  { "id": 5003,"nombre": "Caserio",                     "subCategoria": "Residencial" },
  { "id": 5004,"nombre": "Casa el Bosque",              "subCategoria": "Residencial" },
  { "id": 5005,"nombre": "Canuelas Village",            "subCategoria": "Residencial" },
  { "id": 5006,"nombre": "Comuna 14",                   "subCategoria": "Residencial" },
  { "id": 5007,"nombre": "La Luisita",                  "subCategoria": "Residencial" },
  { "id": 5008,"nombre": "Casa Molvento",               "subCategoria": "Residencial" },
  { "id": 5009,"nombre": "Casa La Serena",              "subCategoria": "Residencial" },
  { "id": 5010,"nombre": "Homes Co",                    "subCategoria": "Residencial" },
  { "id": 5011,"nombre": "Barrio Calandria II",         "subCategoria": "Planificación" },
  { "id": 5012,"nombre": "Puerto Nautico",              "subCategoria": "Planificación" },
  { "id": 5013,"nombre": "Club Nautico",                "subCategoria": "Planificación" },
  { "id": 5014,"nombre": "Casa Cañuelas chico",         "subCategoria": "Residencial" },
  { "id": 5015,"nombre": "Housing Plena",               "subCategoria": "Residencial" },
  { "id": 5016,"nombre": "Parque Industrial Entrance",  "subCategoria": "Planificación" },
  { "id": 5017,"nombre": "Ruka",                        "subCategoria": "Residencial" },
  { "id": 5018,"nombre": "Housing Bali",                "subCategoria": "Residencial" },
  { "id": 5019,"nombre": "Viavara",                     "subCategoria": "Planificación" },
  { "id": 5020,"nombre": "Casas Campo Chico",           "subCategoria": "Residencial" },
  { "id": 5021,"nombre": "Fusina",                      "subCategoria": "Comercial" },
  { "id": 5022,"nombre": "Duplex Brisas",               "subCategoria": "Residencial" },
  { "id": 5023,"nombre": "Housing Serra",               "subCategoria": "Residencial" },
  { "id": 5024,"nombre": "Puerto 53",                   "subCategoria": "Comercial" },
  { "id": 5025,"nombre": "Casa Rustica",                "subCategoria": "Residencial" },
  { "id": 5026,"nombre": "Casa Alta",                   "subCategoria": "Residencial" },
  { "id": 5027,"nombre": "Casa Campestre",              "subCategoria": "Residencial" },
  { "id": 5028,"nombre": "Casa Concreto",               "subCategoria": "Residencial" },
  { "id": 5029,"nombre": "Casa Entre Muros",            "subCategoria": "Residencial" },
  { "id": 5030,"nombre": "Casa Escalonada",             "subCategoria": "Residencial" },
  { "id": 5031,"nombre": "Casa Galería",                "subCategoria": "Residencial" },
  { "id": 5032,"nombre": "Casa Gavion",                 "subCategoria": "Residencial" },
  { "id": 5033,"nombre": "Casa Gris",                   "subCategoria": "Residencial" },
  { "id": 5034,"nombre": "Casa Ladrillo",               "subCategoria": "Residencial" },
  { "id": 5035,"nombre": "Casa Mirador",                "subCategoria": "Residencial" },
  { "id": 5036,"nombre": "Casa Negra",                  "subCategoria": "Residencial" },
  { "id": 5037,"nombre": "Casa Ocre",                   "subCategoria": "Residencial" },
  { "id": 5038,"nombre": "Casa Pétrea",                 "subCategoria": "Residencial" },
  { "id": 5039,"nombre": "Casa Techos",                 "subCategoria": "Residencial" },
  { "id": 5040,"nombre": "Casa Ventana",                "subCategoria": "Residencial" },
  { "id": 5041,"nombre": "Casa San Miguel",             "subCategoria": "Residencial" },
  { "id": 5042,"nombre": "Club House",                  "subCategoria": "Residencial" },
  { "id": 5043,"nombre": "Cabanas Tierra Alta",         "subCategoria": "Residencial" },
  { "id": 5044,"nombre": "Casa Hotel Nomada",           "subCategoria": "Residencial" },
  { "id": 5045,"nombre": "Hotel casa blanca",           "subCategoria": "Residencial" },
  { "id": 5046,"nombre": "Casa Firenze",                "subCategoria": "Residencial" },
  { "id": 5047,"nombre": "Barrio Trina",                "subCategoria": "Planificación" },
  { "id": 5048,"nombre": "Barrio Calandria Norte",      "subCategoria": "Planificación" },
  { "id": 5049,"nombre": "COTA45",                      "subCategoria": "Comercial" },
  { "id": 5050,"nombre": "Centro Comercial Pilar",      "subCategoria": "Comercial" },
  { "id": 5051,"nombre": "Centro Comercial Pila",       "subCategoria": "Comercial" },
  { "id": 8001,"nombre": "Coc",                         "subCategoria": "Diseño" },
  { "id": 8002,"nombre": "Brevet",                      "subCategoria": "Diseño" },
  { "id": 8003,"nombre": "Central Club",                "subCategoria": "Diseño" },
  { "id": 8004,"nombre": "Unito",                       "subCategoria": "Diseño" },
  { "id": 8005,"nombre": "Che Mono",                    "subCategoria": "Diseño" },
  { "id": 8006,"nombre": "Barilatte",                   "subCategoria": "Diseño" },
  { "id": 8007,"nombre": "P53",                         "subCategoria": "Arquitectura" },
  { "id": 8008,"nombre": "Mercadillo",                  "subCategoria": "Diseño" },
  { "id": 8009,"nombre": "La Celeste",                  "subCategoria": "Diseño" },
  { "id": 8010,"nombre": "Homa",                        "subCategoria": "Diseño" },
  { "id": 8011,"nombre": "SUSS",                        "subCategoria": "Diseño" },
  { "id": 8012,"nombre": "Valpo",                       "subCategoria": "Arquitectura" },
  { "id": 8013,"nombre": "Barrio Calandria 2",          "subCategoria": "Arquitectura" },
  { "id": 8014,"nombre": "Comuna 14",                   "subCategoria": "Arquitectura" },
  { "id": 8015,"nombre": "Hosuing Plena",               "subCategoria": "Arquitectura" },
  { "id": 8016,"nombre": "Barrio Calandria Norte",      "subCategoria": "Arquitectura" },
  { "id": 8017,"nombre": "Cota 45",                     "subCategoria": "Arquitectura" },
  { "id": 8018,"nombre": "HAYDEE",                      "subCategoria": "Diseño" },
  { "id": 8019,"nombre": "Distrito F",                  "subCategoria": "Diseño" },
  { "id": 8020,"nombre": "1111",                        "subCategoria": "Arquitectura" },
  { "id": 8021,"nombre": "Once Once",                   "subCategoria": "Arquitectura" }
];


